
import { Injectable } from '@angular/core';
import { DeviceData } from '../../application/application';
import { TokenService } from '../../token/token.service';
import { ApplicationService } from '../../application/application.service';
import { BackendService } from '../../backend.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable()
export class DeviceDetectService {

  private setDeviceDataUrl = '/risk_engine/otrocs/attributes/DeviceData';

  constructor(private tokenService: TokenService, private applicationService: ApplicationService, private backendService: BackendService, private deviceService: DeviceDetectorService) { }

  getDeviceData() {
    const customerId = this.tokenService.getCustomerId();
    if (customerId) {
      const deviceInfo = this.deviceService.getDeviceInfo();
      let deviceType = deviceInfo.device;
      if (deviceType === 'android' || deviceType === 'iphone' || deviceType === 'ipod' || deviceType === 'blackberry' || deviceType === 'windows-phone' || deviceType === 'vita') {
        deviceType = 'Mobile';
      } else if (deviceType === 'ipad' || deviceType === 'firefox-os') {
        deviceType = 'Tablet';
      } else if (deviceType === 'unknown' || deviceType === 'chrome-book' || deviceType === 'ps4') {
        deviceType = 'Desktop';
      }
      let deviceModel = 'unknown';
      if (deviceInfo.device === 'android') {
        const re = /^.*; ([^)]*)/;
        const res = deviceInfo.userAgent.match(re);
        if (!!res) {
          deviceModel = res[1];
        }
      }
      const deviceData = new DeviceData(customerId, deviceType, null, deviceModel, deviceInfo.os, this.applicationService.getApplicationId(), deviceInfo.browser_version, deviceInfo.userAgent);
      this.setDeviceData(deviceData).subscribe(res => {
        // Device data saved sucessfully
      }, error => {
        if (error.status === 500) {
          // Device data failed
        }
      });
    }
  }
  setDeviceData(deviceData: DeviceData): any {
    return this.backendService.setData(this.setDeviceDataUrl, deviceData, null, false, false, true);
  }
  isDesktop() {
    return this.deviceService.isDesktop();
  }
}
